import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {groupBy} from '../../../helpers/utils';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import {LocationCustomerDashboard3} from './subComponents';
import dashboard from '../locales/dashboard.json';

class DashboardBox2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			intervalId: '',
			locationCustomerDashboard: {
				totalOpenWorkOrders: 0,
				workOrders: [],
				inspections: {},
				inspectionsLast1days: {},
				inspectionsLast3days: {},
				inspectionsLast7days: {},
				partInspections: {},
				partInspectionsLast1days: {},
				partInspectionsLast3days: {},
				partInspectionsLast7days: {}
			}
		}
	}

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard);
		this.loadDashboard();

		const intervalId = setInterval(() => {
			this.loadDashboard();
		}, 300000);
		this.setState({intervalId: intervalId});
	}

	componentWillUnmount() {
		clearInterval(this.state.intervalId);
	}

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/2`);

			const totalOpenWorkOrders = response.data.total_open_work_orders;
			const workOrders = response.data.work_orders;
			const inspections = response.data.inspections;
			const inspectionsLast1days = response.data.inspections_last_1_days;
			const inspectionsLast3days = response.data.inspections_last_3_days;
			const inspectionsLast7days = response.data.inspections_last_7_days;
			const partInspections = response.data.part_inspections;
			const partInspectionsLast1days = response.data.part_inspections_last_1_days;
			const partInspectionsLast3days = response.data.part_inspections_last_3_days;
			const partInspectionsLast7days = response.data.part_inspections_last_7_days;

			this.setState({
				locationCustomerDashboard: {
					...this.state.locationCustomerDashboard,
					totalOpenWorkOrders: totalOpenWorkOrders,
					workOrders: workOrders,
					inspections: groupBy(inspections, 'work_order_id'),
					inspectionsLast1days: groupBy(inspectionsLast1days, 'work_order_id'),
					inspectionsLast3days: groupBy(inspectionsLast3days, 'work_order_id'),
					inspectionsLast7days: groupBy(inspectionsLast7days, 'work_order_id'),
					partInspections: groupBy(partInspections, 'work_order_id', 'part_id'),
					partInspectionsLast1days: groupBy(partInspectionsLast1days, 'work_order_id', 'part_id'),
					partInspectionsLast3days: groupBy(partInspectionsLast3days, 'work_order_id', 'part_id'),
					partInspectionsLast7days: groupBy(partInspectionsLast7days, 'work_order_id', 'part_id')
				}
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate, session} = this.props;
		const permissionNames = session.permission_names;

		const content = (
			<div className="content-wrapper">
				<section className="content">
					{
						<LocationCustomerDashboard3 state={this.state.locationCustomerDashboard} permissionNames={permissionNames} translate={translate}
						                           enableViewInspection={false}
						/>
					}
				</section>
			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox2);
